<script>
export default {
  name: 'list-group-item',
  mounted() {},
  props: {
    di: {},
    errors: {
      type: Object,
      default: null
    },
    href: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: null,
    },
    value: {
      default: false,
    },
    trueValue: {
      default: true,
    },
    falseValue: {
      default: false,
    },
    disabled: {
      default: false,
    },
    readonly: {
      default: false,
    },
    tag: {
      type: String,
      default: 'div'
    },
    isLink: Boolean,
    isRouterLink: Boolean,
    routerLinkActive: Boolean,
    routerLinkExact: Boolean,
    to: {}
  },
  render(h) {
    var tag = this.tag
    var self = this
    var propsObject = {
      class: [
        "list-group-item",
        {"disabled":this.disabled},
        { "list-group-item-action": !this.disabled && (this.isLink || this.isRouterLink) },
        { "active": this.isRouterLink && this.routerLinkActive || this.isRouterLink && this.routerLinkExact && this.routerLinkActive },
      ],

    }
    if (!this.disabled) {

      if (this.isLink) {
        tag = 'button'
        propsObject.on = { click: (e) => { self.$emit('click', e) } }
      }
      if (this.isRouterLink && this.to) {
        tag = 'button'
        propsObject.on = {
          click: (e) => { self.$router.push(self.to) },
          keyup: (e) => { console.log('keyup', e) }
        }
      } else {
        propsObject.on = { click: (e) => { self.toggleListGroupItem() } }
      }
    }
    return h(tag, propsObject, this.$slots.default)
  },
  methods: {
    hasError() {
      return this.errors[this.di.name]
    },
    toggleListGroupItem() {
      if (this.disabled || this.readonly) return false
      var value = this.falseValue
      if (this.type === 'checkbox') {
        if (this.value == this.trueValue) value = this.falseValue
        else value = this.trueValue
      }
      if (this.type === 'radio') {
        if (this.value) {
          if (this.value == this.trueValue) {
            value = this.falseValue
          } else {
            value = this.trueValue
          }
        } else {
          value = this.trueValue
        }
      }
      if (this._inGroup) this.$parent.val = value
      this.$emit('input', value)
    }
  },
  computed: {
    active() { return this.value == this.trueValue }
  },
}

</script>
